module.exports = __webpack_public_path__ + "static/img/bg-es.ea5c35c5.png";